import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import "./appointment-create-form.scss";
import "./appointment-details-show.scss";
import { useSelector } from "react-redux";
import { post, put } from "../../utils/fetchAPI";
import { Toast } from "../../utils/SwalUti";

const visitTypeMatches = (value, target) => {
  const v = (value || "").toString().toLowerCase();
  const t = target.toLowerCase();
  if (t === "followup" || t === "follow up") {
    return v === "followup" || v === "follow up" || value === "followUp";
  }
  return v === t;
};

const AppointmentDetailsShow = ({
  selectedAppointmentInfo,
  appointmentUpdatedValue,
  setAppointmentUpdatedValue,
  reset,
  setActionModal,
  setSelectedAppointment,
}) => {
  const [info, setInfo] = useState({ appointmentDate: new Date().toJSON() });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (selectedAppointmentInfo?.type) {
      setAppointmentUpdatedValue((prev) => ({
        ...prev,
        type: selectedAppointmentInfo?.type || "",
        status: selectedAppointmentInfo?.status || "",
      }));
    }
  }, [selectedAppointmentInfo?.type, selectedAppointmentInfo?.status, setAppointmentUpdatedValue]);

  const onSubmit = async (values, { resetForm }) => {
    values = appointmentUpdatedValue;
    setIsSubmitting(true);
    await put(`appointment/update/${selectedAppointmentInfo?._id}`, values)
      .then((res) => {
        if (res.status === 200) {
          updatePatient(info, selectedAppointmentInfo?.patientId);
          setIsSubmitting(false);
          reset();
          setActionModal(false);
        }
      })
      .catch(() => {
        setIsSubmitting(false);
      });
  };

  const setInfoFun = (key, value) => {
    let temp = { ...info };
    setInfo({ ...temp, [key]: value });
  };

  const updatePatient = async (values, patientId) => {
    await post(`/patient/update/${patientId}`, values)
      .then((res) => {
        if (res?.status === 200) {
          Toast.fire({
            icon: "",
            title: "Updated successfully",
          });
        }
      })
      .catch(() => {});
  };

  const vt =
    appointmentUpdatedValue?.type ?? selectedAppointmentInfo?.type ?? "";

  return (
    <Formik
      initialValues={{
        name: "",
        phone: "",
        email: "",
        gender: "",
        dob: "",
        bloodGroup: "",
        maritalStatus: "",
      }}
      onSubmit={onSubmit}
    >
      {() => (
        <div className="appointment-create-form-section appointment-create-form appointment-update-form pb-0">
          <Form
            action=""
            className="custom-form input-section appointment-create-form__form position-relative"
            encType="multipart/form-data"
          >
            <div className="row mt-0 pt-0 g-1">
              <div className="col-12 appointment-create-form__panel">
                <h3 className="appointment-create-form__section-title">Patient</h3>
                <div className="col-12 appointment-create-form__row">
                  <label htmlFor="upd-name" className="appointment-create-form__label">
                    Name<span className="text-danger">*</span>
                  </label>
                  <input
                    required
                    id="upd-name"
                    className="form-control input appointment-create-form__control"
                    autoComplete="off"
                    type="text"
                    name="name"
                    value={selectedAppointmentInfo?.patientName || ""}
                    placeholder="Name"
                    onChange={(e) => {
                      setInfoFun("name", e.target.value);
                      setSelectedAppointment({
                        ...selectedAppointmentInfo,
                        patientName: e.target.value,
                      });
                      setAppointmentUpdatedValue({
                        ...appointmentUpdatedValue,
                        patientName: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12 appointment-create-form__row">
                  <label htmlFor="upd-patient-id" className="appointment-create-form__label">
                    Patient ID
                  </label>
                  <input
                    id="upd-patient-id"
                    className="form-control input appointment-create-form__control"
                    disabled
                    value={selectedAppointmentInfo?.patient?.patientId || ""}
                  />
                </div>
                <div className="col-12 appointment-create-form__row">
                  <label htmlFor="upd-phone" className="appointment-create-form__label">
                    Phone
                  </label>
                  <input
                    id="upd-phone"
                    className="form-control input appointment-create-form__control"
                    disabled
                    pattern="(^(01){1}[3-9]{1}\d{8})$"
                    type="text"
                    value={selectedAppointmentInfo.patientPhone || ""}
                  />
                </div>
                <div className="col-12 appointment-create-form__row">
                  <label htmlFor="upd-dob" className="appointment-create-form__label">
                    Date of birth
                  </label>
                  <input
                    id="upd-dob"
                    className="form-control input appointment-create-form__control"
                    autoComplete="off"
                    type="date"
                    value={selectedAppointmentInfo?.patientDob?.slice(0, 10) || ""}
                    onChange={(e) => {
                      setInfoFun("dob", e.target.value);
                      setSelectedAppointment({
                        ...selectedAppointmentInfo,
                        patientDob: e.target.value,
                      });
                      setAppointmentUpdatedValue({
                        ...appointmentUpdatedValue,
                        patientDob: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12 appointment-create-form__row appointment-create-form__row--radios">
                  <span id="upd-gender-group" className="appointment-create-form__label">
                    Gender
                  </span>
                  <div
                    role="radiogroup"
                    aria-labelledby="upd-gender-group"
                    className="appointment-create-form__radio-group"
                  >
                    <label className="appointment-create-form__radio">
                      <input
                        type="radio"
                        name="upd-gender"
                        checked={
                          selectedAppointmentInfo?.patientGender?.toLowerCase() ===
                          "male"
                        }
                        onChange={() => {
                          setInfoFun("gender", "Male");
                          setSelectedAppointment({
                            ...selectedAppointmentInfo,
                            patientGender: "Male",
                          });
                          setAppointmentUpdatedValue({
                            ...appointmentUpdatedValue,
                            patientGender: "Male",
                          });
                        }}
                      />
                      <span>Male</span>
                    </label>
                    <label className="appointment-create-form__radio">
                      <input
                        type="radio"
                        name="upd-gender"
                        checked={
                          selectedAppointmentInfo?.patientGender?.toLowerCase() ===
                          "female"
                        }
                        onChange={() => {
                          setInfoFun("gender", "Female");
                          setSelectedAppointment({
                            ...selectedAppointmentInfo,
                            patientGender: "Female",
                          });
                          setAppointmentUpdatedValue({
                            ...appointmentUpdatedValue,
                            patientGender: "Female",
                          });
                        }}
                      />
                      <span>Female</span>
                    </label>
                  </div>
                </div>
                {user?.user?.type?.toLowerCase() === "staff" && (
                  <div className="col-12 appointment-create-form__row">
                    <label className="appointment-create-form__label">Doctor</label>
                    <input
                      className="form-control input appointment-create-form__control appointment-create-form__control--readonly w-100"
                      readOnly
                      type="text"
                      value={selectedAppointmentInfo?.doctorName || ""}
                    />
                  </div>
                )}
              </div>

              <div className="col-12 appointment-create-form__panel">
                <h3 className="appointment-create-form__section-title">Appointment</h3>
                <div className="col-12 appointment-create-form__row">
                  <label htmlFor="upd-status" className="appointment-create-form__label">
                    Status
                  </label>
                  <select
                    id="upd-status"
                    className="appointment-create-form__control appointment-create-form__control--full"
                    onChange={(e) => {
                      setAppointmentUpdatedValue({
                        ...appointmentUpdatedValue,
                        status: e.target.value,
                      });
                    }}
                    value={appointmentUpdatedValue?.status || ""}
                  >
                    <option value="present">Present</option>
                    <option value="pending">Pending</option>
                    <option value="canceled">Canceled</option>
                  </select>
                </div>
                <div className="col-12 appointment-create-form__row">
                  <label htmlFor="upd-appt-date" className="appointment-create-form__label">
                    Appointment date<span className="text-danger">*</span>
                  </label>
                  <input
                    id="upd-appt-date"
                    required
                    className="form-control input appointment-create-form__control"
                    autoComplete="off"
                    type="date"
                    value={
                      appointmentUpdatedValue?.date?.slice(0, 10) ||
                      selectedAppointmentInfo?.date?.slice(0, 10) ||
                      ""
                    }
                    onChange={(e) => {
                      setAppointmentUpdatedValue({
                        ...appointmentUpdatedValue,
                        date: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-12 appointment-create-form__row appointment-create-form__row--type">
                  <span id="upd-type-group" className="appointment-create-form__label">
                    Visit type<span className="text-danger">*</span>
                  </span>
                  <div
                    role="radiogroup"
                    aria-labelledby="upd-type-group"
                    aria-required="true"
                    className="appointment-create-form__radio-group appointment-create-form__radio-group--wrap"
                  >
                    <label className="appointment-create-form__radio">
                      <input
                        type="radio"
                        name="upd-appointment-type"
                        checked={visitTypeMatches(vt, "new")}
                        onChange={() => {
                          setAppointmentUpdatedValue({
                            ...appointmentUpdatedValue,
                            type: "new",
                          });
                        }}
                      />
                      <span>New</span>
                    </label>
                    <label className="appointment-create-form__radio">
                      <input
                        type="radio"
                        name="upd-appointment-type"
                        checked={visitTypeMatches(vt, "old")}
                        onChange={() => {
                          setAppointmentUpdatedValue({
                            ...appointmentUpdatedValue,
                            type: "old",
                          });
                        }}
                      />
                      <span>Old</span>
                    </label>
                    <label className="appointment-create-form__radio">
                      <input
                        type="radio"
                        name="upd-appointment-type"
                        checked={visitTypeMatches(vt, "followUp")}
                        onChange={() => {
                          setAppointmentUpdatedValue({
                            ...appointmentUpdatedValue,
                            type: "followUp",
                          });
                        }}
                      />
                      <span>Follow up</span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-12 appointment-create-form__actions">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn submit-button appointment-create-form__submit"
                >
                  Save changes
                  {isSubmitting && (
                    <span
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </button>
              </div>
            </div>
          </Form>
        </div>
      )}
    </Formik>
  );
};

export default AppointmentDetailsShow;
